import { useQuery } from 'react-query';
import { WebsiteMessageAPI } from 'api/websiteMessage';
import { WEBSITE_MESSAGES } from 'helpers/constants';

export default function useWebsiteMessages() {
  return useQuery(WEBSITE_MESSAGES, WebsiteMessageAPI.getWebsiteMessages);
}
